import React from 'react'
import styled from 'styled-components'

import { withTranslation } from '../../i18n'
import { getColor, getFontSize } from '../../utils/cssUtils'
import { toCurrency } from '../../utils/formatter'
import Avatar from '../Avatar'

const RankWrapper = styled.div`
  display: flex;
  flex-flow: row nowrap;
  padding: 16px 0;
  width: 100%;
  position: relative;
  &:after {
    content: '';
    display: block;
    width: calc(100% - 60px);
    height: 1px;
    background-color: ${getColor('lightGrey', 0.2)};
    position: absolute;
    bottom: 0;
    right: 0;
  }
  &:last-of-type {
    &:after {
      display: none;
    }
  }
`
const RankNumber = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: ${getFontSize('title')};
  min-width: 32px;
  margin-right: 12px;
`
const RankContent = styled.div`
  min-width: 0;
`
const Creator = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  margin-bottom: 4px;
`
const RankInfo = styled.div`
  display: flex;
  flex-flow: row nowrap;
`
const Name = styled.div`
  min-width: 0;
  margin-left: 8px;
  color: ${getColor('black')};
  font-size: ${getFontSize('body2')};
`
const EllipsisText = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`
const Label = styled.div`
  display: inline-block;
  color: ${getColor('grey')};
  margin-right: 2px;
`
const Value = styled.div`
  display: inline-block;
  color: ${getColor('black')};
  font-weight: 600;
`
const DonationCount = styled.div`
  min-width: 112px;
`

// use withTranslation because useTranslation leads to a extra render
// https://github.com/isaachinman/next-i18next/issues/654
const FundraisingRank = withTranslation('common')(
  ({
    creatorName,
    avatarUrl,
    rank,
    totalDonorCount,
    totalDonationAmount,
    className,
    t
  }) => {
    return (
      <RankWrapper className={className}>
        <RankNumber>{rank}</RankNumber>
        <RankContent>
          <Creator>
            <Avatar size={32} src={avatarUrl} />
            <Name>
              <EllipsisText>{creatorName}</EllipsisText>
            </Name>
          </Creator>
          <RankInfo>
            <DonationCount>
              <Label>{t('project.donorCount')}</Label>
              <Value>{totalDonorCount}</Value>
            </DonationCount>
            <div>
              <Label>{t('project.fundraised')}</Label>
              <Value>
                {t('common.currencyNoSymbol') + toCurrency(totalDonationAmount)}
              </Value>
            </div>
          </RankInfo>
        </RankContent>
      </RankWrapper>
    )
  }
)

export default FundraisingRank
